<template>
    <div class="banner" :class="[{ closed: closed }]" role="banner">
        <div class="banner__logo">
            <img
                :src="assetUrl('images/logo-app.svg')"
                alt="Hammer: Truck GPS Navigation"
                title="For professional truck drivers"
                width="46"
                height="46"
            />
        </div>
        <div class="banner__content">
            <h2>
                Hammer: Truck GPS Navigation
                <span class="banner__rating">
                    <span
                        v-for="(star, starKey) in filledStars"
                        :key="`rating-filled-${starKey}`"
                        class="banner__rating-star--filled"
                    >
                        <svg>
                            <use :xlink:href="`${icons['star']}#icon`"></use>
                        </svg>
                    </span>
                    <span
                        v-for="(star, starKey) in emptyStars"
                        :key="`rating-empty-${starKey}`"
                        class="banner__rating-star--empty"
                    >
                        <svg>
                            <use :xlink:href="`${icons['star']}#icon`"></use>
                        </svg>
                    </span>
                </span>
            </h2>
            <p>For professional truck drivers</p>
        </div>
        <div class="banner__stores">
            <a
                href="https://apps.apple.com/cz/app/hammer-truck-gps-navigation/id1478863996"
                rel="external"
            >
                <img
                    :src="assetUrl('images/store_appstore.png')"
                    alt="Hammer: Truck GPS Navigation - Available on the App store"
                    title="Available on the App store"
                    width="149"
                    height="44"
                />
            </a>
            <a
                href="https://play.google.com/store/apps/details?id=com.truckersreport.hammer&gl=US"
                rel="external"
            >
                <img
                    :src="assetUrl('images/store_googleplay.png')"
                    alt="Hammer: Truck GPS Navigation - Available on the Google Play"
                    title="Available on the Google Play"
                    width="149"
                    height="44"
                />
            </a>
        </div>
        <div class="banner__close" @click="close">
            <!-- <progress-ring
                :radius="17"
                :progress="progress"
                :stroke="3"
                :duration="disappear"
                :color="'#DBD1C9'"
            ></progress-ring> -->
            <span class="banner__icon-close">
                <svg>
                    <use :xlink:href="`${icons['close']}#icon`"></use>
                </svg>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: ['rating', 'disappear'],
    data() {
        return {
            icons: window.here.icons,
            closed: false,
            progress: 100,
        };
    },
    computed: {
        filledStars() {
            return new Array(parseInt(this.rating, 10));
        },
        emptyStars() {
            return new Array(5 - parseInt(this.rating, 10));
        },
    },
    mounted() {
        // this.setCloseAfterTimeout();
    },
    methods: {
        setCloseAfterTimeout() {
            this.progress = 0;
            setTimeout(() => {
                this.close();
            }, this.disappear * 1000);
        },
        close() {
            this.closed = true;
            this.$parent.downloadBanner = false;
        },
    },
};
</script>

<style lang="scss" scoped>
/* ==========================================================================
   Banner
   ========================================================================== */

.banner {
    width: 898px;
    height: 68px;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    box-shadow: 0 6px 15px 0 rgba(0, 0, 0, 0.08);
    padding: 12px;
    border-radius: 4px;
    display: flex;
    transition: transform 600ms ease-in-out;
    z-index: 5;

    & > * {
        flex: 1 0 auto;
    }
}

.banner.closed {
    transform: translate(-50%, 100%);
}

.banner__logo {
    width: 46px;
    height: 46px;
    max-width: 46px;
}

.banner__content {
    padding-left: 13px;
    h2 {
        font-weight: 600;
        font-size: 18px;
        letter-spacing: 0.08px;
        margin: 0;
        line-height: 24px;
        color: #4e3a30;
        align-items: center;
        display: flex;
    }

    p {
        color: rgba(78, 58, 48, 0.6);
        font-size: 14px;
    }
}

.banner__stores {
    max-width: 306px;
    font-size: 0;
    a {
        display: inline-block;
    }
    a + a {
        margin-left: 8px;
    }
}

.banner__rating {
    font-size: 0;
    display: inline-block;
    padding-left: 40px;
    white-space: nowrap;
}

.banner__close {
    max-width: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 12px;
    cursor: pointer;
    position: relative;
}

.banner__rating-star--filled,
.banner__rating-star--empty {
    display: inline-block;
    svg {
        width: 20px;
        height: 20px;
    }

    &.banner__rating-star--filled {
        color: #ffb100;
    }

    &.banner__rating-star--empty {
        color: rgba(78, 58, 48, 0.2);
    }
}

.banner__icon-close {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: rgba(78, 58, 48, 0.6);
    transition: color 300ms;

    &:hover {
        color: rgba(40, 27, 20, 0.87);
    }

    svg {
        width: 22px;
        height: 22px;
    }
}
</style>
